import Link from 'next/link'
import React from 'react'

import { processLink } from '@/_utils/link.utils'

export interface LinkedAmbulanceData {
	url: string
	title: string
	text: string
	buttonText: string
}

export interface BEditorJsLinkedAmbulanceProps {
	data: LinkedAmbulanceData
}

const LinkedAmublanceCard = ({ data }: { data: LinkedAmbulanceData }) => {
	const { url, title, text, buttonText } = data

	return (
		<div className='editorjs-renderer_block'>
			<div className='bg-[#8061CD] px-8 py-12 my-6 rounded-lg text-white relative overflow-hidden'>
				{title && title?.length > 0 && (
					<div className='text-3xl font-base mb-3'>{title}</div>
				)}
				{text && text?.length > 0 && (
					<div className='text-base font-light text-[#f7f5ef] w-4/5 max-w-[500px]'>
						{text}
					</div>
				)}

				{buttonText && buttonText?.length > 0 && url && url?.length > 0 && (
					<Link
						{...processLink(url)}
						title='Hero link'
						className='btn_basic type13 wmin200 mt-8'
					>
						<span>{buttonText}</span>
						<span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar2_r' />
								</svg>
							</span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar2_r' />
								</svg>
							</span>
						</span>
					</Link>
				)}

				<div className='absolute bottom-0 right-[-40px] z-0 pointer-events-none'>
					<img
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/legacy/mala-vlnka-3.svg`}
						alt='Ilustračná fotografia'
						className='max-w-[200px] max-h-[100px] opacity-20 pointer-events-none'
						loading='lazy'
					/>
				</div>
			</div>
		</div>
	)
}

export const BEditorJsLinkedAmbulance: React.FC<BEditorJsLinkedAmbulanceProps> = ({ data }) => {
	if (!data.text && !data.title) {
		return null
	}

	return <LinkedAmublanceCard data={data} />
}

export default BEditorJsLinkedAmbulance
